<template>
  <div class="user-profile-template" theme>
    <div id="theme-user-profile" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'user',
      parts: [
        {
          elem: '#theme-user-profile',
          htmlFile: 'profile'
        }
      ]
    }
  },
  mounted() {
    if (!this.loggedInUser) {
      this.openLink('/login')
    }
  }
}
</script>
